// Pixel sizes for the banner title, keyed by the token stored on the
// Organization. Keeping the mapping here rather than on the server means a design
// rescale is a constant change instead of a data migration.
//
// Sizes are Figma measurements: the org banner title is 32px, NOT the 48px used
// for the player's name. Only LARGE is reachable today — there is no editor for
// the token and every Organization defaults there — so SMALL/MEDIUM exist to keep
// the ladder honest, not because anything selects them.

export type TeamNameFontSize = 'small' | 'medium' | 'large'

export const TITLE_FONT_SIZE_PX: Record<TeamNameFontSize, number> = {
  small: 24,
  medium: 28,
  large: 32
}

export const DEFAULT_TITLE_FONT_SIZE: TeamNameFontSize = 'large'

/** Resolves an unknown or missing token to the default rather than rendering nothing. */
export const resolveTitleFontSize = (token?: string): number =>
  TITLE_FONT_SIZE_PX[(token as TeamNameFontSize) in TITLE_FONT_SIZE_PX
    ? (token as TeamNameFontSize)
    : DEFAULT_TITLE_FONT_SIZE]
